import { third } from 'components/CameraModelSelector/style'
import { COLORS } from 'helpers/globals'

export default {
  CameraDetails: {
    ...third,
    color: 'black',
    width: '100%',
    padding: '.7rem',
    position: 'relative',
    '& img': {
      maxHeight: '10rem',
      maxWidth: '10rem',
      marginBottom: '1rem',
      alignSelf: 'start'
    },
    '& h4': {
      marginBottom: '.5rem'
    }
  },
  table: {
    width: 'auto',
    marginBottom: '1rem',
    '& td': {
      padding: '.5rem 1rem .5rem .5rem',
      border: 'none'
    },
    '& > tbody > tr': {
      '&:nth-child(even)': {
        background: COLORS.tertiary
      }
    }
  },
  selectCameraButton: {
    width: '100%',
    fontSize: '1.4rem',
    borderRadius: '.5rem',
    '& svg': {
      marginRight: '.6rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/style.js